import { isNative, PUBLIC_HOME } from "@/lib/native";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { Sparkles, Compass, Star, BookOpen, Clock, User, MessageCircle } from "lucide-react";

const TABS = [
  { to: "/today", label: "Today", icon: Sparkles, testId: "nav-today" },
  { to: "/chart", label: "Chart", icon: Compass, testId: "nav-chart" },
  { to: "/signs", label: "Signs", icon: Star, testId: "nav-signs" },
  { to: "/ask", label: "Ask", icon: MessageCircle, testId: "nav-ask" },
  { to: "/readings", label: "Readings", icon: BookOpen, testId: "nav-readings" },
  { to: "/history", label: "Archive", icon: Clock, testId: "nav-history" },
  { to: "/profile", label: "Sanctuary", icon: User, testId: "nav-profile" },
];

export const navTabs = () => TABS.filter((t) => !(isNative && t.to === "/readings"));

export default function BottomNav({ className = "" }) {
  return (
    <nav data-testid="bottom-nav" className={`bottom-nav fixed bottom-0 left-0 right-0 max-w-md mx-auto z-40 backdrop-blur-2xl bg-[#080B14]/95 border-t border-[#D4AF37]/25 px-1 pt-2 safe-bottom flex items-center justify-around ${className}`}>
      {navTabs().map((t) => {
        const Icon = t.icon;
        return (
          <NavLink
            key={t.to}
            to={t.to}
            data-testid={t.testId}
            className={({ isActive }) =>
              `flex flex-col items-center gap-0.5 px-1 py-1.5 min-w-[44px] rounded-xl transition-colors ${
                isActive ? "gold-text" : "text-[#6c7686] hover:text-[#A7B0C0]"
              }`
            }
          >
            <Icon size={20} />
            <span className="text-[10px] tracking-wide">{t.label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}

// Logged-out preview menu: Signs is home, Ask opens the free guest chat, Readings is public, the rest open a preview.
export function PublicNav({ onLocked, className = "" }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const OPEN = { "/signs": PUBLIC_HOME, "/ask": "/try", "/readings": "/readings" };
  return (
    <nav data-testid="public-nav" className={`bottom-nav fixed bottom-0 left-0 right-0 max-w-md mx-auto z-40 backdrop-blur-2xl bg-[#080B14]/95 border-t border-[#D4AF37]/25 px-1 pt-2 safe-bottom flex items-center justify-around ${className}`}>
      {navTabs().map((t) => {
        const Icon = t.icon;
        const active = OPEN[t.to] && (t.to === "/signs" ? pathname === PUBLIC_HOME : pathname.startsWith(OPEN[t.to]));
        return (
          <button
            key={t.to}
            data-testid={`public-${t.testId}`}
            onClick={() => (active ? window.scrollTo({ top: 0, behavior: "smooth" }) : OPEN[t.to] ? navigate(OPEN[t.to]) : onLocked(t.label))}
            className={`flex flex-col items-center gap-0.5 px-1 py-1.5 min-w-[44px] rounded-xl transition-colors ${active ? "gold-text" : "text-[#6c7686] hover:text-[#A7B0C0]"}`}
          >
            <Icon size={20} />
            <span className="text-[10px] tracking-wide">{t.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
